module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATBAMAAACEi/vCAAAAHlBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaVcReAAAACnRSTlMAgFsyC1MdJnYGOYTIQQAAADpJREFUCNdjYMAB2IwToCxFwQAIg1kQxmIVNHGAsJgEYRrgLCYNQSUDMItRUFAQwSrAqYMMFqcLiAQA+MoEqHfphI8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/socialLink/logo_fb.png
// module id = 716
// module chunks = 0